/**
 * Margine inline-start del contenuto principale, allineato al drawer desktop.
 * Valore aggiornato da `DesktopSidebarProvider` su `--adams-nav-drawer-width`.
 */
export const NAV_LAYOUT_MARGIN_START = 'var(--adams-nav-drawer-width, 256px)'
